import messages from 'i18n/messages';
import { FormattedMessage } from 'react-intl';
import { getLocalStorage } from './handleStorage';
import { getFieldLabelOverride } from 'i18n/fieldLabels';

export const i18n = (id) => {
  // Las etiquetas de campo renombradas por grupo pisan al JSON. `i18Intl` no pasa por
  // aquí: sus overrides van mergeados en el IntlProvider (containers/Wrapper.js).
  const override = getFieldLabelOverride(id);

  if (override !== undefined) {
    return override;
  }

  const locale = getLocalStorage('locale');

  if (locale) {
    let message = messages[locale][id];

    if (message !== undefined) {
      return message;
    }
  }

  return id;
};

export const i18nKey = (translation) => {
  let messagesList = messages[getLocalStorage('locale')];

  let key = Object.keys(messagesList).find((key) => messagesList[key] === translation);

  if (key !== undefined) {
    return key;
  } else {
    return translation;
  }
};

export const i18Intl = (id) => {
  return id !== null ? <FormattedMessage id={id} /> : '';
};

export const literalsOptionsTranslator = (list) => {
  let arrayNew = [];
  if (list) {
    arrayNew = list.map((item) => ({
      ...item,
      value: item.value,
      label: item.label,
    }));
    return arrayNew;
  }
  return [];
};

export const literalsOptionsTranslatorMeasureGenericType = (list) => {
  let arrayNew = [];
  if (list) {
    arrayNew = list.map((item) => ({
      value: item.value,
      label: i18n(item.label),
    }));
    return arrayNew.sort((a, b) => (a.label > b.label ? 1 : b.label > a.label ? -1 : 0));
  }
  return [];
};

export const literalsOptionsTranslatorMeasureStatus = (list) => {
  let arrayNew = [];
  if (list) {
    arrayNew = list.map((item) => ({
      value: item.value,
      label: i18n(`measure.status.${item.label}`),
    }));
    return arrayNew.reverse();
  }
  return [];
};
